import { useQuery } from '@tanstack/react-query';

import getPromoList from 'Api/stock-promo/getPromoList';
import getPromoListResponse from 'Domain/stock-promo/model/response/getPromoListResponse';
import getPromoListRequest from 'Domain/stock-promo/model/request/getPromoListRequest';

const useGetPromoList = ({ enabled, params }) => {
  return useQuery({
    queryKey: ['promo-list', params],
    queryFn: async () => {
      const queryParams = getPromoListRequest(params);
      
      const response = await getPromoList(queryParams);

      return getPromoListResponse(response.data);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetPromoList;
